import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { createConfigSelector, getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { locales } from '@americanexpress/conditional-features';

const useLocationSyncWithLocaleHook = (router, location) => {
  const locale = useSelector(getActiveLocaleSelector);
  const prevLocale = useRef();
  const zhRedirectionUrl = useSelector(createConfigSelector('zhHKRedirectUrl'));

  const lowercaseLocale = locale.toLowerCase();

  const hasLocaleChanged = prevLocale.current && lowercaseLocale !== prevLocale.current;
  const isLocaleDifferentToLocation = lowercaseLocale !== location?.params?.locale;

  const needLocaleRedirect = hasLocaleChanged && isLocaleDifferentToLocation;

  useEffect(() => {
    if (needLocaleRedirect) {
      if (locale === locales.ZH_HK) {
        window.location.assign(zhRedirectionUrl);
      } else {
        const redirectUrl = `${location?.pathname.replace(prevLocale.current, lowercaseLocale)}${location?.search}`;
        router.push(redirectUrl);
      }
    }
    prevLocale.current = lowercaseLocale;
  }, [locale, needLocaleRedirect, location, router, zhRedirectionUrl]);

  return needLocaleRedirect;
};

export default useLocationSyncWithLocaleHook;
